import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import { withRouter } from "../../shared/utility";
import VisitorLogForm from "../../components/forms/visitor/VisitorLogForm";
import AuditActionLink from "../../components/audit/AuditActionLink";
import { VisitorLogViewModel } from "../../viewmodels/visitorsLog/VisitorLogViewModel";
import EmptyModal from "../../components/modals/EmptyModal";
import FormSectionLoadingSkeleton from "../../components/operational/FormSectionLoadingSkeleton";

function VisitorLog(props) {
  const { addSnackbar, logout } = props;
  const navigate = useNavigate();
  const { id } = useParams();

  const {
    inProgress,
    createVisitor,
    visitorTypeOptions,
    getVisitorTypesForDropdown,
    emptyModal,
    setEmptyModelOpen,
    loading,
    visitor,
    getVisitorDetails,
    updateVisitor,
    checkoutVisitor,
  } = VisitorLogViewModel(logout, id, addSnackbar);

  useEffect(() => {
    getVisitorTypesForDropdown();
    if (!!id) {
      getVisitorDetails();
    }
  }, []);

  const onCreateVisitor = async (payload) => {
    const res = await createVisitor(payload);
    if (res.success) {
      navigate("/visitors");
    }
  };

  return (
    <div>
      <div className="mt-2 px-4 sm:px-8">
        {loading ? (
          <FormSectionLoadingSkeleton />
        ) : (
          <>
            {id && visitor ? (
              <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
                <h1 className="text-xl font-semibold text-gray-900">
                  {visitor.name}
                </h1>
                <AuditActionLink
                  slug="visitor-log"
                  id={visitor.id}
                  name={visitor.name}
                />
              </div>
            ) : null}
            <VisitorLogForm
              inProgress={inProgress}
              visitor={visitor}
              updateVisitor={updateVisitor}
              checkoutVisitor={checkoutVisitor}
              onCreateVisitor={onCreateVisitor}
              onCancel={() => navigate("/visitors")}
              visitorTypeOptions={visitorTypeOptions}
            />
          </>
        )}
      </div>

      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
        size={emptyModal.size}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(VisitorLog),
);
